export default {
  props: {
    formKey: String,
    formModel: Object,
  },
  data () {
    return {
      observableError: '',
      observableValue: '',
      blurredFormInput: false // поле если было затронуто - можно валидировать на каждый keyup
    }
  },
  mounted () {
    this.$on('blur', this.blurValidateForm.bind(this))
    this.$on('change', this.blurValidateForm.bind(this))
    this.$on('input', this.lifeValidateForm.bind(this))
    this.lifeValidateForm()

    if (this.formModel) {
      this.formModel.$on('validateFields', this.updateFieldErrorText)
    }
  },
  beforeDestroy () {
    this.$off(['blur', 'input', 'change'])

    if (this.formModel) {
      this.formModel.$off(['validateFields'])
    }
  },
  methods: {

    blurValidateForm () {
      this.blurredFormInput = true

      return this.lifeValidateForm()
    },

    // живая валидация - по каждому нажатию
    lifeValidateForm () {

      let valid = true

      const changeValid = validateResult => {
        if (!valid) {
          return
        }

        valid = validateResult
      }

      // новая валидация
      changeValid(this.validate2Form())

      return valid
    },

    validate2Form () {

      if (!this.formKey || !this.formModel) {
        return true
      }

      if (!this.formModel.$v2) {
        return true
      }

      const vObject = this.formModel._vuelidate2

      // поле было затронуто
      if (this.blurredFormInput) {
        vObject.setBlurredField(this.formKey)
      }

      const fieldError = vObject.validateField(this.formKey)

      this.observableError = vObject.isBlurredField(this.formKey) && fieldError ? fieldError : ''

      return !this.observableError
    },

    // обновить текст ошибки
    updateFieldErrorText () {

      if (!this.formKey || !this.formModel) {
        return
      }

      if (!this.formModel.$v2) {
        return
      }

      const vObject = this.formModel._vuelidate2

      const { errors } = this.formModel.$v2

      const errorObj = errors[this.formKey] || null

      this.observableError = vObject.isBlurredField(this.formKey) && errorObj ? errorObj.fieldError : ''
    }
  },
  computed: {}
}
